export const countingAnimation = ({ start, end, duration, target, comma = false, decimal = 0 }) => {
  let startTimestamp = null;
  const easeOutQuad = (t) => t * (2 - t);

  const step = (timestamp) => {
    if (!startTimestamp) startTimestamp = timestamp;
    const progress = easeOutQuad(Math.min((timestamp - startTimestamp) / duration, 1));
    const num = progress * (end - start) + start;
    if (comma) {
      target.textContent = Number(num.toFixed(decimal)).toLocaleString();
    } else {
      target.textContent = num.toFixed(decimal);
    }
    if (progress < 1) {
      requestAnimationFrame(step);
    }
  };
  requestAnimationFrame(step);
};

window.animationHelper = {};
window.animationHelper.countingAnimation = countingAnimation;
